import React, { useState, useRef, useEffect } from "react";
import { getNpcComponent } from "../../utils/openAI-utils";
import { ReactComponent as RecordIcon } from "../icons/recording.svg";
import styles from "./AudioRecordingAI.scss";
import { getAIEntity } from "../../utils/openAI-utils";
import aiAgents from "../../singleton/AIAgents";
import { AGENT_EVENTS } from "../../utils/agent-utils";
import { Body1 } from "@fluentui/react-components";

export function AudioSpeaker({ receiver, scene, onTalking, onResetIdle, talking, loadingSpeech, onLoadingSpeech }) {
  const initialOuterSize = 160;
  const initialMiddleCircleSize = 155;
  const initialInnerCircleSize = 150;
  const [outerCircleSize, setOuterCircleSize] = useState(initialOuterSize);
  const [middleCircleSize, setMiddleCircleSize] = useState(initialMiddleCircleSize);
  const [innerCircleSize, setInnerCircleSize] = useState(initialInnerCircleSize);
  const [bars, setBars] = useState([16, 16, 16, 16]);

  const receiverRef = useRef(null);
  receiverRef.current = receiver;
  const agent = aiAgents.getAgentById(receiverRef.current);
  const aiEntity = agent.el;
  const npcComponent = getNpcComponent(aiEntity);
  let intervalId = useRef(null);

  function updateBars() {
    clearInterval(intervalId.current);
    intervalId.current = setInterval(() => {
      // As we Can't use by the moment the volume of the audio
      // we have to simulate it with random values
      let barElements = bars;
      for (let i = 0; i < barElements.length; i++) {
        const normalizedVolume = 1 + Math.random() * 2; // Fake volume level between 0.5 and 3
        const height = Math.max(16, normalizedVolume * 16);

        barElements[i] = height;
      }
      setBars(barElements);

      const normalizeCircle = 1 + Math.random() * 2;

      const outerSize = Math.max(160, 150 + normalizeCircle * 40);
      const middleSize = Math.max(155, 150 + normalizeCircle * 30);
      const innerSize = Math.max(150, 150 + normalizeCircle * 15);

      setOuterCircleSize(outerSize);
      setMiddleCircleSize(middleSize);
      setInnerCircleSize(innerSize);
    }, 150);
  }

  function idleBars() {
    clearInterval(intervalId.current);
    intervalId.current = setInterval(() => {
      const normalizeCircle = 1 + Math.random() * 2;

      const outerSize = Math.max(160, 150 + normalizeCircle * 10);
      const middleSize = Math.max(155, 150 + normalizeCircle * 5);
      const innerSize = Math.max(150, 150 + normalizeCircle * 3);

      setOuterCircleSize(outerSize);
      setMiddleCircleSize(middleSize);
      setInnerCircleSize(innerSize);
    }, 150);

    setBars([16, 16, 16, 16]);
  }

  useEffect(() => {
    if (talking && npcComponent?.el) {
      updateBars();
    }
  }, [talking, npcComponent]);

  const resetBars = () => {
    clearInterval(intervalId.current);
    setBars([24, 24, 24, 24]);
    setOuterCircleSize(240);
    setMiddleCircleSize(235);
    setInnerCircleSize(230);
  };

  useEffect(() => {
    if (!talking) {
      idleBars();
    }

    if (loadingSpeech && !talking) {
      idleBars();
    }
  }, [talking, loadingSpeech]);

  return (
    <div className={styles.endRecordButton}>
      <div className="audio-button-speaker">
        <div className="audio-circle outer-circle" style={{ width: outerCircleSize, height: outerCircleSize }}></div>
        <div className="audio-circle middle-circle" style={{ width: middleCircleSize, height: middleCircleSize }}></div>
        <div className="audio-circle inner-circle" style={{ width: innerCircleSize, height: innerCircleSize }}></div>
        {/* </div> */}
        <div className="audio-button">
          <div className="audio-button-inner" id="speaker-bot-container">
            <div
              id="bot-bar-1"
              className="audio-button-inner-element"
              style={{ height: loadingSpeech || talking ? bars[0] : "16px" }}
            ></div>
            <div
              id="bot-bar-2"
              className="audio-button-inner-element"
              style={{ height: loadingSpeech || talking ? bars[1] : "16px" }}
            ></div>
            <div
              id="bot-bar-3"
              className="audio-button-inner-element"
              style={{ height: loadingSpeech || talking ? bars[2] : "16px" }}
            ></div>
            <div
              id="bot-bar-4"
              className="audio-button-inner-element"
              style={{ height: loadingSpeech || talking ? bars[3] : "16px" }}
            ></div>
          </div>
        </div>
      </div>
      {!document.hasFocus() && (
        <Body1 style={{ textAlign: "center" }}>
          Current tab is not focused. Please click here to receive and send prompts by voice with AI
        </Body1>
      )}
    </div>
  );
}

export function RecordButtonInput({ recording, setRecording }) {
  return (
    <div className={styles.recordButton} onClick={recording ? () => setRecording(false) : () => setRecording(true)}>
      <RecordIcon />
    </div>
  );
}
